import { render, staticRenderFns } from "./send-points-modal.vue?vue&type=template&id=d6c38e96&"
import script from "./send-points-modal.vue?vue&type=script&lang=js&"
export * from "./send-points-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports